module.exports = __webpack_public_path__ + "static/media/Dinh_Nguyen_DDS.ad39a7e9.png";